"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VariantAssignmentServiceClient = void 0;
const HeaderNames_1 = require("../enums/HeaderNames");
const AxiosHttpClient_1 = require("../utils/AxiosHttpClient");
const TreatmentAssignmentVariantServiceResponse_1 = require("./TreatmentAssignmentVariantServiceResponse");
const package_json_1 = __importDefault(require("../../package.json"));
const cache_control_parser_1 = __importDefault(require("cache-control-parser"));
const common_1 = require("../utils/common");
class VariantAssignmentServiceClient {
    constructor(settings) {
        var _a, _b;
        this.settings = settings;
        if (!settings) {
            throw new Error('settings is null or undefined');
        }
        this.maxCachedResponseAge = (_a = settings.responseCacheTime) !== null && _a !== void 0 ? _a : 0;
        this.enableCaching = (_b = settings.enableCaching) !== null && _b !== void 0 ? _b : false;
        this.httpClient = new AxiosHttpClient_1.AxiosHttpClient();
    }
    async getVariantAssignments(assignmentRequest) {
        if (!assignmentRequest)
            assignmentRequest = {};
        const cachedResponse = this.enableCaching
            ? this.tryGetCachedResponse(assignmentRequest)
            : undefined;
        if (cachedResponse) {
            return cachedResponse;
        }
        return await this.getServerResponse(assignmentRequest);
    }
    tryGetCachedResponse(assignmentRequest) {
        const cacheKey = this.getCacheKey(assignmentRequest);
        const jsonData = sessionStorage.getItem(cacheKey);
        if (!jsonData) {
            return undefined;
        }
        const cachedObj = JSON.parse(jsonData);
        const validUntil = new Date(cachedObj.validUntil);
        const now = new Date();
        if (validUntil.getTime() < now.getTime()) {
            sessionStorage.removeItem(cacheKey);
            return undefined;
        }
        return cachedObj;
    }
    async getServerResponse(assignmentRequest) {
        const headers = this.getHeaders(assignmentRequest);
        const apiResponse = await this.httpClient.get(this.settings.endpoint, { headers: headers });
        const serviceResponseMapper = apiResponse.data;
        const response = new TreatmentAssignmentVariantServiceResponse_1.TreatmentAssignmentVariantServiceResponse(serviceResponseMapper.AssignmentContext, serviceResponseMapper.FlightingVersion, serviceResponseMapper.Configs);
        if (this.enableCaching)
            this.applyCacheDirectives(apiResponse, response, assignmentRequest);
        return response;
    }
    applyCacheDirectives(apiResponse, response, assignmentRequest) {
        const now = new Date();
        //Converting maxCachedResponseAge into milliseconds from seconds
        let validUntil = new Date(now.getTime() + this.maxCachedResponseAge * 1000);
        const cacheKey = this.getCacheKey(assignmentRequest);
        if ((apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.headers) && apiResponse.headers['cache-control']) {
            const cacheControl = cache_control_parser_1.default(apiResponse.headers['cache-control']);
            if (cacheControl) {
                if (cacheControl.noStore) {
                    sessionStorage.removeItem(cacheKey);
                    return;
                }
                if (cacheControl.noCache || cacheControl.mustRevalidate) {
                    validUntil = new Date(0); //Min date i.e. Jan 01 1970
                }
                else if (cacheControl.maxAge && cacheControl.maxAge < this.maxCachedResponseAge) {
                    validUntil = new Date(now.getTime() + cacheControl.maxAge * 1000); //Converting maxAge into milliseconds from seconds
                }
            }
        }
        response.validUntil = validUntil;
        const jsonData = JSON.stringify(response);
        sessionStorage.setItem(cacheKey, jsonData);
    }
    getCacheKey(assignmentRequest) {
        const jsonData = JSON.stringify(assignmentRequest);
        return common_1.getHashCode(jsonData);
    }
    getHeaders(assignmentRequest) {
        var _a, _b, _c;
        const headers = {};
        //Parameters
        if (assignmentRequest === null || assignmentRequest === void 0 ? void 0 : assignmentRequest.parameters) {
            const params = [];
            assignmentRequest.parameters.forEach((values, key) => {
                values === null || values === void 0 ? void 0 : values.forEach((val) => {
                    if (val) {
                        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(val));
                    }
                });
            });
            if (params.length > 0)
                headers[HeaderNames_1.HeaderNames.Parameters] = params;
        }
        //AssignmentScopes
        const assignmentScopes = [];
        (_a = assignmentRequest === null || assignmentRequest === void 0 ? void 0 : assignmentRequest.assignmentScopes) === null || _a === void 0 ? void 0 : _a.forEach((value) => {
            if (value && value.trim() !== '')
                assignmentScopes.push(encodeURIComponent(value));
        });
        if (assignmentScopes.length > 0)
            headers[HeaderNames_1.HeaderNames.AssignmentScopes] = assignmentScopes;
        //RequiredVariants
        const requiredVariants = [];
        (_b = assignmentRequest === null || assignmentRequest === void 0 ? void 0 : assignmentRequest.requiredVariants) === null || _b === void 0 ? void 0 : _b.forEach((value) => {
            if (value && value.trim() !== '')
                requiredVariants.push(encodeURIComponent(value));
        });
        if (requiredVariants.length > 0)
            headers[HeaderNames_1.HeaderNames.RequiredVariants] = requiredVariants;
        //BlockedVariants
        const blockedVariants = [];
        (_c = assignmentRequest === null || assignmentRequest === void 0 ? void 0 : assignmentRequest.blockedVariants) === null || _c === void 0 ? void 0 : _c.forEach((value) => {
            if (value && value.trim() !== '')
                blockedVariants.push(encodeURIComponent(value));
        });
        if (blockedVariants.length > 0)
            headers[HeaderNames_1.HeaderNames.BlockedVariants] = blockedVariants;
        //SDK version
        headers[HeaderNames_1.HeaderNames.SdkVersion] = package_json_1.default.version;
        return headers;
    }
}
exports.VariantAssignmentServiceClient = VariantAssignmentServiceClient;
//# sourceMappingURL=VariantAssignmentServiceClient.js.map